import { css, html, LitElement } from 'lit-element';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import computed from '@giswebgroup/ki-wcp-base/src/decorators/computed';
import responsive from '@giswebgroup/ki-wcp-base/src/decorators/responsive';
import * as moment from 'moment';
import '@giswebgroup/ki-wcp-base/src/components/ki-icon/ki-icon-btn';
import query from '@giswebgroup/ki-wcp-base/src/decorators/query';
import LoaderMixin from '@giswebgroup/ki-wcp-base/src/common/LoaderMixin';
import autoRun from '@giswebgroup/ki-wcp-base/src/decorators/autoRun';
import nls from '../../locales/index.nls';
import '@material/mwc-select';
import '@material/mwc-list/mwc-list-item';

export default
@responsive
@i18n(nls)
class KiAnnualReport extends LoaderMixin(LitElement) {
  // language=CSS
  static styles = css`
    :host {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .year {
      width: 100px;
    }
    .annual-report {
      flex: 1;
    }
    :host(.sm-screen) #close-btn {
      display: none;
    }

    #close-btn {
      position: absolute;
      z-index: 11;
      top: 10px;
      right: 30px;
    }
    iframe{
      flex: 1;
    }
  `;

  constructor() {
    super();
    this.path = 'DCENN/L5021';
    this.year = moment().year(); // default year: current year
  }

  static get properties() {
    return {
      path: { type: String },
      year: { type: String },
      reportSrv: { type: String },
    };
  }

  @computed(['path', 'year'])
  get _srcPath() {
    // http://vm-webdev-1.kisters.de/reports/annual?parameter_path=DGH/6621/Q,DGH/6621/H&year=2010
    const path = `${this.path}/Q,${this.path}/H&year=${this.year}`
    return new URL(`${this.reportSrv}/annual?parameter_path=${path}`, window.location.origin).href;
  }

  @query('#iframeNode')
  _iframeNode;

  render() {
    // language=html
    return html`
      ${this._renderLoader()}
      <mwc-select class="year" .value="${this.year}" @action="${this.__handleAction}"> ${this.__renderYearList()} </mwc-select>
      <ki-icon-btn id="close-btn" icon="ki ki-times" @click="${this.closeElement}"></ki-icon-btn>
      <paper-tooltip for="close-btn">${this.i18n.t('closeView')}</paper-tooltip>
      <iframe src="/services/pdfjs/web/viewer.html?file=${encodeURIComponent(this._srcPath)}" @load="${this._stopLoading}"></iframe>
    `;
  }

  @autoRun('_srcPath')
  _loading() {
    this.__$loaderCount = 1;
    this.requestUpdate();
  }

  _stopLoading() {
    this.__$loaderCount -= 1;
    this.requestUpdate();
  }

  // eslint-disable-next-line class-methods-use-this
  __renderYearList() {
    const arr = [];
    // eslint-disable-next-line no-plusplus
    for (let n = 0; n < 50; n++) arr[n] = moment().year() - n;
    return arr.map(item => {
      return html`<mwc-list-item .value=${item}>${item}</mwc-list-item>`;
    });
  }

  __handleAction(event) {
    this.year = moment().year() - event.detail.index;
  }

  closeElement() {
    this.dispatchEvent(
      new CustomEvent('close', {
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('ki-annual-report', KiAnnualReport);
